<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import moment from "moment";
import axios from "axios";
import Swal from "sweetalert2";
import Papa from "papaparse";
import jwt_decode from "jwt-decode";

export default {
  page: {
    title: "Agents List cards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    flatPickr,
  },
  data() {
    return {
      title: "Agents | Scheduled Messages",
      items: [
        { text: "Agents", href: "/" },
        { text: "Agent List cards", active: true },
      ],
      timeConfig: {
        enableTime: false,
        dateFormat: "d M, Y",
      },
      dateTimeConfig: {
        enableTime: true,
        dateFormat: "m-d-y H:i K",
      },
      list: [],
      messageList: [],
      reciepientList: [],
      content: [],
      numberOfRecipents: 0,
      humanfriendlyConfig: {
        dateFormat: "F j, Y",
      },
      scheduleMessageContent: "",
      scheduleHour: "14:00",

      page: 1,
      perPage: 50,
      pages: [],

      uploadLanguage: "0",

      data: {
        token: localStorage.getItem("jwt"),
        searchValues: {
          isActive: 1,
          noteSearch: "",
          keyword: "",
          licensed: "1", // string para que calce con los <option value="...">
          language: "3",
          orderBy: "ASC",
          sortBy: "name",
          department: "0",
          dateRange: 0,
          status: "0",
          type: "0",
          toDate: new Date().toLocaleDateString("en-us", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
          fromDate: new Date(
              new Date().setFullYear(new Date().getFullYear() - 1)
          ).toLocaleDateString("en-us", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
        },
      },

      statusList: {},
      typeList: {},
      departmentList: {},

      parsed: false,

      // 1 = Agents, 2 = Clients, 3 = Prospects
      findAgents: "1",

      spectedColumns: ["Full name (optional)", "First Name", "Last Name", "Phone", "Email"],

      date: "",
      totalCharacters: 0,
      availableMessages: 0,

      files: [],
      file: null,
      editingMessageId: null,
    };
  },

  watch: {
    list() {
      this.setPages();
    },


    findAgents: {
      async handler() {
        // Limpieza
        this.page = 1;
        this.list = []; // ✅ fuerza render inmediato
        this.data.searchValues.keyword = "";
        this.data.searchValues.status = "0";
        this.data.searchValues.type = "0";
        this.data.searchValues.licensed = "1";
        this.data.searchValues.language = "3";

        await this.updateRecipientsList();
      },
      immediate: false,
    },
  },

  created() {
    this.setPages();
  },

  computed: {
    displayedPosts() {
      return this.paginate(this.list);
    },
    resultQuery() {
      const kw = (this.data.searchValues.keyword || "").trim().toLowerCase();

      // ✅ Si no hay keyword válido => sin filtro
      if (kw.length < 3) return this.displayedPosts;

      return this.displayedPosts.filter((row) => {
        return (
            ((row.firstName || "") + " " + (row.lastName || "")).toLowerCase().includes(kw) ||
            (row.email || "").toLowerCase().includes(kw) ||
            (row.phoneNumber || "").toLowerCase().includes(kw) ||
            (row.statusName || "").toLowerCase().includes(kw) ||
            (row.departmentName || "").toLowerCase().includes(kw)
        );
      });
    },
    
    characterCount() {
      return (this.scheduleMessageContent || '').length;
    },
    
    characterCountDisplay() {
      return `${this.characterCount}/150`;
    },
    
    characterCountBadgeClass() {
      const count = this.characterCount;
      if (count >= 150) {
        return 'badge bg-danger';
      } else if (count > 60) {
        return 'badge bg-warning';
      } else {
        return 'badge bg-secondary';
      }
    },
    
    canScheduleMessage() {
      return this.characterCount <= 150 && this.characterCount > 0;
    },

  },

  methods: {
    formatDate(date, format) {
      return moment(date).format(format);
    },

    toggleSelectAll(event) {
      const isChecked = event.target.checked;
      const checkboxes = document.getElementsByName("chk_child_main");
      
      checkboxes.forEach((checkbox) => {
        checkbox.checked = isChecked;
        const row = checkbox.closest("tr");
        if (row) {
          if (isChecked) {
            row.classList.add("table-active");
          } else {
            row.classList.remove("table-active");
          }
        }
      });
    },

    toggleRowSelection(event) {
      const isChecked = event.target.checked;
      const tr = event.target.closest("tr");
      
      if (tr) {
        if (isChecked) {
          tr.classList.add("table-active");
        } else {
          tr.classList.remove("table-active");
        }
      }

      // Update "Select All" checkbox state
      this.updateSelectAllCheckbox();
    },

    isRowSelected() {
      // This is used for initial rendering based on checked state
      return false;
    },

    updateSelectAllCheckbox() {
      const checkboxes = document.getElementsByName("chk_child_main");
      const selectAllCheckbox = document.getElementById("checkAllRecipients");
      
      if (selectAllCheckbox && checkboxes.length > 0) {
        const allChecked = Array.from(checkboxes).every(cb => cb.checked);
        const noneChecked = Array.from(checkboxes).every(cb => !cb.checked);
        
        selectAllCheckbox.checked = allChecked;
        selectAllCheckbox.indeterminate = !allChecked && !noneChecked;
      }
    },

    async editMessage(message) {
      // Populate form with message data
      this.scheduleMessageContent = message.message || '';
      this.date = message.scheduledTo ? moment(message.scheduledTo).format('MMMM DD, YYYY') : '';
      this.scheduleHour = message.scheduledTo ? moment(message.scheduledTo).format('HH:mm') : '14:00';
      
      // Store the message ID for updating
      this.editingMessageId = message.ID || null;

      // Fetch recipients for this message
      if (message.ID) {
        const data = {
          token: localStorage.getItem("jwt"),
          messageID: message.ID
        };

        try {
          const response = await axios.post("/api/comm/getMessageRecipients", data);
          if (response.data && Array.isArray(response.data)) {
            this.reciepientList = response.data;
            this.numberOfRecipents = response.data.length;
          }
        } catch (error) {
          if (error.response && error.response.data.detail === "Your session is expired!") {
            this.$router.push("logout");
          }
          console.error("Could not load recipients:", error);
          // Don't show error to user, just log it
        }
      }
    },

    setPages() {
      const numberOfPages = Math.ceil(this.list.length / this.perPage);
      this.pages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },

    paginate(contactsList) {
      // ✅ si no es array, retorna vacío
      if (!Array.isArray(contactsList)) return [];

      const page = this.page;
      const perPage = this.perPage;
      const from = page * perPage - perPage;
      const to = page * perPage;

      return contactsList.slice(from, to);
    },

    formatPhone(phone, flag = 0) {
      if (phone !== undefined && phone !== null) {
        const x = phone.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        phone = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
      } else {
        phone = "";
      }

      if (flag !== 1) {
        return phone;
      } else {
        const el = document.getElementById("editPhoneNumber");
        if (el) el.value = phone;
      }
    },

    async addRecipients() {
      let ids_array = [];
      let items = document.getElementsByName("chk_child_main");
      let url = "";

      items.forEach(function (ele) {
        if (ele.checked === true) {
          let trNode = ele.closest("tr");
          let id = trNode.querySelector(".id a")?.innerHTML;

          if (id && !ids_array.includes(id)) {
            ids_array.push(id);
          }
        }
      });

      if (typeof ids_array !== "undefined" && ids_array.length > 0) {
        const data = {
          token: localStorage.getItem("jwt"),
          recipientsList: ids_array.join(),
        };

        if (this.findAgents === "1") {
          url = "/api/getUserByids";
        } else {
          url = "/api/client/getClientsByiDS";
        }

        await axios
            .post(url, data)
            .then((response) => {
              let array1 = JSON.parse(JSON.stringify(this.reciepientList));
              let array2 = JSON.parse(JSON.stringify(response.data));
              let array3 = array1.concat(array2);

              array3 = array3.filter(
                  (value, index, self) =>
                      index ===
                      self.findIndex((t) => t.ID === value.ID && t.phoneNumber === value.phoneNumber)
              );

              this.reciepientList = JSON.parse(JSON.stringify(array3));
              this.numberOfRecipents = this.reciepientList.length;

              items.forEach(function (ele) {
                if (ele.checked === true) {
                  ele.checked = false;
                  ele.closest("tr")?.classList.remove("table-active");
                }
              });
            })
            .catch((error) => {
              if (error.response) {
                Swal.fire("Oops!", "Departments could not be loaded, please contact your SysAdmin.", "error");
              }
            });
      } else {
        Swal.fire({
          title: "Please, select at least one recipient!",
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },

    async addRecipientsFromFile() {
      let language = this.uploadLanguage;

      if (this.content?.data?.length > 0 && language !== "0") {
        let array1 = JSON.parse(JSON.stringify(this.reciepientList));
        let array2 = JSON.parse(JSON.stringify(this.content.data));
        let array3 = [];

        array2.forEach(function (item) {
          let firstName = "";
          let lastName = "";

          if ((item["First Name"] || "").length > 1 && (item["Last Name"] || "").length > 1) {
            firstName = item["First Name"];
            lastName = item["Last Name"];
          } else {
            // FIX: antes era split('') => chars. Ahora split por espacios
            const full = (item["Full name (optional)"] || "").trim();
            const parts = full.split(" ").filter(Boolean);
            firstName = parts[0] || "";
            lastName = parts.slice(1).join(" ") || "";
          }

          array3.push({
            ID: 0,
            departmentName: "n/a",
            email: item["Email"],
            firstName: firstName,
            language: language,
            lastName: lastName,
            phoneNumber: item["Phone"],
            statusName: "n/a",
          });
        });

        this.reciepientList = array1.concat(array3);
        this.numberOfRecipents = this.reciepientList.length;

        const btn = document.getElementById("closeListModal");
        if (btn) btn.click();
      } else if (this.uploadLanguage === "0") {
        Swal.fire({
          title: "Please, select the language!",
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      } else {
        Swal.fire({
          title: "Please, upload almost one recipient in the list!",
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },

    removeRecipient(index) {
      Swal.fire({
        title: "Are you sure?",
        text: "This recipient will be removed!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#2ca219",
        confirmButtonColor: "#e12e2e",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          // FIX: antes era indexOf(index)
          this.reciepientList.splice(index, 1);
          Swal.fire("Deleted!", "Recipient has been deleted.", "success");
          this.numberOfRecipents = this.reciepientList.length;
        }
      });
    },

    async scheduleMessage() {
      let validate = true;
      let errors = [];

      if (this.scheduleMessageContent === "" || this.scheduleMessageContent.length < 10) {
        errors.push("Message should be longer than 10 characters!");
        validate = false;
      }

      if (this.scheduleHour === "" || this.scheduleHour.length < 3) {
        errors.push("Please, set the schedule hour for the message!");
        validate = false;
      }

      if (this.reciepientList.length === 0) {
        errors.push("Please, add almost one recipient to the list!");
        validate = false;
      }

      if (this.totalCharacters < 0) {
        errors.push("Your message is longer than 150 characters!");
        validate = false;
      }

      if (this.availableMessages <= 0) {
        errors.push("You reached the limit of daily messages!");
        validate = false;
      }

      if (this.reciepientList.length > this.availableMessages) {
        errors.push("You can't add more recipients than you message limit!");
        validate = false;
      }

      const data = {
        token: localStorage.getItem("jwt"),
        recipients: this.reciepientList,
        hour: this.scheduleHour,
        date: this.date,
        message: this.scheduleMessageContent,
        userEmail: localStorage.getItem("email"),
      };

      if (validate) {
        await axios
            .post("/api/comm/saveScheduleMessage", data)
            .then(() => {
              const btn = document.getElementById("closemodal");
              if (btn) btn.click();
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Message scheduled successfully!",
              });
            })
            .catch((error) => {
              if (error.response) {
                Swal.fire("Oops!", "Please contact your SysAdmin.", "error");
              }
            });
      } else {
        await Swal.fire(errors.join("\n"), "", "info");
      }
    },

    resetForm() {
      this.numberOfRecipents = 0;
      this.scheduleMessageContent = "";
      this.scheduleHour = "14:00";
      this.reciepientList = [];
      this.editingMessageId = null;

      // default date = hoy
      this.date = new Date().toLocaleDateString("en-us", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      this.getQuota();
    },

    async updateAgentList(status = "0") {
      let validate = true;
      let errors = [];

      this.data.searchValues.status = status;

      const filterKeyword = (this.data.searchValues.keyword || "").trim();
      if (filterKeyword !== "" && filterKeyword.length < 3) {
        errors.push("Keyword search should have 3 or more characters!");
        validate = false;
      }

      const data = {
        token: localStorage.getItem("jwt"),
        searchValues: this.data.searchValues,
        isAgent: this.data.searchValues.licensed,
        userEmail: localStorage.getItem("email"),
      };

      if (!validate) {
        await Swal.fire(errors.join("\n"), "", "info");
        return;
      }

      axios
          .post("/api/listAgents", data)
          .then((response) => {
            this.list = Array.isArray(response.data) ? response.data : [];
            this.page = 1;
            this.setPages();
          })
          .catch((error) => {
            if (error.response && error.response.data.detail === "Your session is expired!") {
              this.$router.push("logout");
            }
          });
    },

    parseFile() {
      var allowedExtensions = /(\.csv)$/i;

      if (this.file && allowedExtensions.exec(this.file.name)) {
        Papa.parse(this.file, {
          header: true,
          skipEmptyLines: true,
          complete: function (results) {
            if (this.compare(this.spectedColumns, results.meta.fields)) {
              this.content = results;
              this.parsed = true;
            } else {
              Swal.fire({
                title: "Oops, this file is not what we spected!",
                icon: "warning",
                confirmButtonClass: "btn btn-info",
                buttonsStyling: false,
                showCloseButton: true,
              });
            }
          }.bind(this),
        });
      } else {
        Swal.fire({
          title: "File extension not supported!",
          icon: "warning",
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },

    handleFileUpload() {
      this.file = document.getElementById("listFile")?.files?.[0] || null;
      if (this.file) this.parseFile();
    },

    compare(o1, o2) {
      for (let p in o1) {
        if (Object.prototype.hasOwnProperty.call(o1, p)) {
          if (o1[p] !== o2[p]) return false;
        }
      }
      for (let p in o2) {
        if (Object.prototype.hasOwnProperty.call(o2, p)) {
          if (o1[p] !== o2[p]) return false;
        }
      }
      return true;
    },

    deleteRecord(ele) {
      ele?.target?.parentElement?.parentElement?.remove();
    },

    async updateRecipientsList() {
      let data = {};

      // AGENTS
      if (this.findAgents === "1") {
        data = {
          token: localStorage.getItem("jwt"),
          searchValues: this.data.searchValues,
          isAgent: 1,
          userEmail: localStorage.getItem("email"),
        };

        await axios
            .post("/api/listDepartments", data)
            .then((response) => {
              this.departmentList = response.data;
            })
            .catch(() => {
              Swal.fire("Oops!", "Departments could not be loaded, please contact your SysAdmin.", "error");
            });

        await axios
            .post("/api/listStatus", data)
            .then((response) => {
              this.statusList = response.data;
            })
            .catch(() => {
              Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
            });

        await axios
            .post("/api/listAgents", data)
            .then((response) => {
              this.list = response.data;
              this.page = 1;
              this.setPages();
            })
            .catch(() => {});

        await axios
            .post("/api/listSource", data)
            .then((response) => {
              this.typeList = response.data;
            })
            .catch((error) => {
              if (error.response && error.response.data.detail === "Your session is expired!") {
                this.$router.push("logout");
              }
              Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
            });

        return;
      }

      // CLIENTS / PROSPECTS
      data = {
        token: localStorage.getItem("jwt"),
        searchValues: this.data.searchValues,
        userEmail: localStorage.getItem("email"),
        userID: localStorage.getItem("id"),
        isProspect: 0,
        deleted: 0,
        agentSearch: [],
      };

      if (this.findAgents === "3") {
        data.isProspect = 1;
      }

      await axios
          .post("/api/client/listClients", data)
          .then((response) => {
            // ✅ aquí está el fix real
            this.list = Array.isArray(response.data?.results) ? response.data.results : [];

            // ✅ opcional pero recomendado:
            this.perPage = response.data?.perPage || 50;

            this.page = 1;
            this.setPages();
          })
          .catch((error) => {
            if (error.response && error.response.data.detail === "Your session is expired!") {
              this.$router.push("logout");
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
          });

      await axios
          .post("/api/client/clientStatus", data)
          .then((response) => {
            this.statusList = response.data;
          })
          .catch((error) => {
            if (error.response && error.response.data.detail === "Your session is expired!") {
              this.$router.push("logout");
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
          });

      await axios
          .post("/api/client/clientTypes", data)
          .then((response) => {
            this.typeList = response.data;
          })
          .catch((error) => {
            if (error.response && error.response.data.detail === "Your session is expired!") {
              this.$router.push("logout");
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
          });

      console.log(this.findAgents);
    },

    characterCounter() {
      const textArea = document.getElementById("exampleFormControlTextarea5");
      const characterCounter = document.getElementById("char_count");
      const maxNumOfChars = 150;

      if (!textArea || !characterCounter) return;

      const numOfEnteredChars = textArea.value.length;
      const counter = maxNumOfChars - numOfEnteredChars;

      characterCounter.textContent = counter + "/150";
      this.totalCharacters = counter;

      if (counter < 0) characterCounter.style.color = "red";
      else if (counter < 100) characterCounter.style.color = "orange";
      else characterCounter.style.color = "black";
    },

    async getQuota() {
      const url = "api/comm/getSMSQuota";

      const data = {
        token: localStorage.getItem("jwt"),
        message: this.scheduleMessageContent,
        userEmail: localStorage.getItem("email"),
      };

      await axios
          .post(url, data)
          .then((response) => {
            this.availableMessages = parseInt(response.data.scheduleCount) + parseInt(response.data.totalSent);
            this.availableMessages = 100 - this.availableMessages;

            if (this.viewUserGroup("SUPER_ADMIN_GROUP")) {
              this.availableMessages = 10000;
            }
          })
          .catch(() => {
            Swal.fire("Oops!", "Please contact your SysAdmin.", "error");
          });
    },

    viewUserGroup(request) {
      const currentRole = jwt_decode(localStorage.getItem("jwt"));
      return currentRole.userGroup.includes(request);
    },
  },

  async mounted() {
    let data = {};

    if (this.findAgents === "1") {
      data = {
        token: localStorage.getItem("jwt"),
        searchValues: this.data.searchValues,
        isAgent: 1,
        userEmail: localStorage.getItem("email"),
      };

      await axios
          .post("/api/listDepartments", data)
          .then((response) => {
            this.departmentList = response.data;
          })
          .catch(() => {
            Swal.fire("Oops!", "Departments could not be loaded, please contact your SysAdmin.", "error");
          });

      await axios
          .post("/api/listStatus", data)
          .then((response) => {
            this.statusList = response.data;
          })
          .catch(() => {
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
          });

      await axios
          .post("/api/listAgents", data)
          .then((response) => {
            this.list = response.data;
            this.page = 1;
            this.setPages();
          })
          .catch(() => {});

      await axios
          .post("/api/listSource", data)
          .then((response) => {
            this.typeList = response.data;
          })
          .catch((error) => {
            if (error.response && error.response.data.detail === "Your session is expired!") {
              this.$router.push("logout");
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
          });
    } else {
      data = {
        token: localStorage.getItem("jwt"),
        searchValues: this.data.searchValues,
        userEmail: localStorage.getItem("email"),
        userID: localStorage.getItem("id"),
        isProspect: 0,
        deleted: 0,
        agentSearch: [],
      };

      await axios
          .post("/api/client/clientStatus", data)
          .then((response) => {
            this.statusList = response.data;
          })
          .catch((error) => {
            if (error.response && error.response.data.detail === "Your session is expired!") {
              this.$router.push("logout");
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
          });

      await axios
          .post("/api/client/clientTypes", data)
          .then((response) => {
            this.typeList = response.data;
          })
          .catch((error) => {
            if (error.response && error.response.data.detail === "Your session is expired!") {
              this.$router.push("logout");
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error");
          });
    }

    await axios
        .post("/api/comm/getScheduledMessages", data)
        .then((response) => {
          this.messageList = response.data;
        })
        .catch((error) => {
          if (error.response && error.response.data.detail === "Your session is expired!") {
            this.$router.push("logout");
          }
        });

// ✅ solo carga Agents si estás en Agents
    if (this.findAgents === "1") {
      this.updateAgentList();
    } else {
      this.updateRecipientsList();
    }

    this.getQuota();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="leadsList">
          <div class="card-header border-0">
            <div class="row g-4 align-items-center">
              <div class="col-sm-3">
                <div class="search-box">
                  <input type="text" class="form-control search" placeholder="Search for..." />
                  <i class="ri-search-line search-icon"></i>
                </div>
              </div>

              <div class="col-sm-auto ms-auto">
                <div class="hstack gap-2">
                  <button type="button" class="btn btn-soft-success add-btn" href="#open-filters" data-bs-toggle="modal">
                    <i class="ri-filter-line align-bottom me-1"></i> Filters
                  </button>

                  <button type="button" class="btn btn-soft-success" href="#createMessage" data-bs-toggle="modal" @click="resetForm">
                    <i class="ri-message-2-line align-bottom me-1"></i> Create Message
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="card-body">
            <div class="table-responsive table-card">
              <table class="table table-hover align-middle table-nowrap mb-0">
                <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 50px">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="checkAll" value="option" />
                    </div>
                  </th>
                  <th scope="col">Message</th>
                  <th scope="col" class="text-center">Status</th>
                  <th scope="col" class="text-center">Sent</th>
                  <th scope="col">Scheduled For</th>
                  <th scope="col">Created On</th>
                  <th scope="col" class="text-center">Actions</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="(data, index) of messageList" :key="index">
                  <td>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" />
                    </div>
                  </td>

                  <td>
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 me-2">
                        <div class="avatar-xs">
                          <div class="avatar-title bg-primary-subtle text-primary rounded fs-16 fw-semibold">
                            {{ data.message ? data.message.charAt(0).toUpperCase() : 'M' }}
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="fs-14 mb-0">{{ data.message }}</h6>
                      </div>
                    </div>
                  </td>

                  <td class="text-center">
                    <span v-if="data.active === 1" class="badge bg-success-subtle text-success">
                      <i class="ri-checkbox-circle-line align-middle me-1"></i>Active
                    </span>
                    <span v-else class="badge bg-danger-subtle text-danger">
                      <i class="ri-close-circle-line align-middle me-1"></i>Inactive
                    </span>
                  </td>

                  <td class="text-center">
                    <span v-if="data.sent === 1" class="badge bg-info-subtle text-info">
                      <i class="ri-send-plane-2-line align-middle me-1"></i>Sent
                    </span>
                    <span v-else class="badge bg-warning-subtle text-warning">
                      <i class="ri-time-line align-middle me-1"></i>Pending
                    </span>
                  </td>

                  <td>
                    <div class="d-flex align-items-center">
                      <i class="ri-calendar-event-line text-muted me-2"></i>
                      <span class="text-muted">{{ formatDate(data.scheduledTo, "MMM DD, YYYY") }}</span>
                      <i class="ri-time-line text-muted ms-3 me-2"></i>
                      <span class="text-muted">{{ formatDate(data.scheduledTo, "h:mm A") }}</span>
                    </div>
                  </td>

                  <td>
                    <small class="text-muted">{{ formatDate(data.createdOn, "MMM DD, YYYY h:mm A") }}</small>
                  </td>

                  <td class="text-center">
                    <div class="hstack gap-2 justify-content-center">
                      <button 
                        class="btn btn-sm btn-soft-primary" 
                        data-bs-toggle="modal" 
                        href="#createMessage" 
                        title="Edit"
                        @click="editMessage(data)"
                      >
                        <i class="ri-pencil-fill"></i>
                      </button>

                      <button 
                        class="btn btn-sm btn-soft-danger" 
                        data-bs-toggle="tooltip" 
                        title="Delete"
                      >
                        <i class="ri-delete-bin-fill"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

              <!-- Empty State -->
              <div v-if="messageList.length === 0" class="text-center py-5">
                <div class="avatar-lg mx-auto mb-3">
                  <div class="avatar-title bg-soft-primary text-primary rounded-circle fs-1">
                    <i class="ri-mail-line"></i>
                  </div>
                </div>
                <h5 class="text-muted">No Scheduled Messages</h5>
                <p class="text-muted">Create your first scheduled message to get started.</p>
              </div>
            </div>

            <!-- Pagination -->
            <div class="d-flex justify-content-between align-items-center mt-3 px-2" v-if="messageList.length > 0">
              <div class="text-muted">
                Showing <strong>1-{{ messageList.length }}</strong> of <strong>{{ messageList.length }}</strong> messages
              </div>
              <nav aria-label="Page navigation">
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item disabled">
                    <a class="page-link" href="#" tabindex="-1">
                      <i class="ri-arrow-left-s-line"></i> Previous
                    </a>
                  </li>
                  <li class="page-item active"><a class="page-link" href="#">1</a></li>
                  <li class="page-item disabled">
                    <a class="page-link" href="#">
                      Next <i class="ri-arrow-right-s-line"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filters Modal -->
    <div id="open-filters" class="modal fade" tabindex="-1" aria-hidden="true" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Filters</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <label for="filtersKeyword" class="form-label">Keyword</label>
                <input
                    type="text"
                    id="filtersKeyword"
                    name="filtersKeyword"
                    class="form-control mb-2"
                    placeholder="Enter Keyword"
                    v-model="data.searchValues.keyword"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <label for="filtersLicensed" class="form-label">Licensed agents?</label>
                <select class="form-select mb-2" id="filtersLicensed" name="filtersLicensed" v-model="data.searchValues.licensed">
                  <option value="1">Both</option>
                  <option value="2">Yes</option>
                  <option value="3">No</option>
                </select>
              </div>

              <div class="col-lg-6">
                <div
                    class="form-check form-switch form-switch-lg"
                    dir="ltr"
                    style="margin: 0; position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);"
                >
                  <input type="checkbox" class="form-check-input" id="filtersIsActive" checked="" />
                  <label class="form-check-label" for="filtersIsActive">Active</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <label for="filtersLanguage" class="form-label">Language</label>
                <select class="form-select mb-2" id="filtersLanguage" name="filtersLanguage" v-model="data.searchValues.language">
                  <option value="3">Both</option>
                  <option value="1">English</option>
                  <option value="2">Spanish</option>
                </select>
              </div>

              <div class="col-lg-6">
                <label for="filtersNotes" class="form-label">Search by Notes</label>
                <input
                    type="text"
                    id="filtersNotes"
                    name="filtersNotes"
                    class="form-control mb-2"
                    placeholder="Enter note"
                    v-model="data.searchValues.noteSearch"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <label for="filtersFromDate" class="form-label">From date</label>
                <flat-pickr
                    v-model="data.searchValues.fromDate"
                    :config="humanfriendlyConfig"
                    class="form-control flatpickr-input"
                    id="filtersFromDate"
                    name="filtersFromDate"
                ></flat-pickr>
              </div>

              <div class="col-lg-6">
                <label for="filtersToDate" class="form-label">To Date</label>
                <flat-pickr
                    v-model="data.searchValues.toDate"
                    :config="humanfriendlyConfig"
                    class="form-control flatpickr-input"
                    id="filtersToDate"
                    name="filtersToDate"
                ></flat-pickr>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="updateAgentList()">Search</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Create message Modal -->
    <div
        id="createMessage"
        class="modal fade"
        tabindex="-1"
        aria-hidden="true"
        style="display: none;"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create Schedule Message</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body bg-body-secondary" style="padding: 25px;">
            <div class="row g-4">
              <!-- LEFT SIDE - Message Details -->
              <div class="col-lg-5">
                <div class="card shadow-sm h-100">
                  <div class="card-header bg-primary text-white">
                    <h6 class="mb-0"><i class="ri-message-2-line me-2"></i>Message Details</h6>
                  </div>
                  <div class="card-body">
                    <!-- Schedule Date & Time -->
                    <div class="row g-3 mb-3">
                      <div class="col-6">
                        <label for="cmDate" class="form-label fw-semibold">
                          <i class="ri-calendar-line me-1 text-primary"></i>Date
                        </label>
                        <flat-pickr
                            v-model="date"
                            :config="humanfriendlyConfig"
                            class="form-control"
                            id="cmDate"
                            name="cmDate"
                        ></flat-pickr>
                      </div>

                      <div class="col-6">
                        <label for="cmHour" class="form-label fw-semibold">
                          <i class="ri-time-line me-1 text-primary"></i>Time
                        </label>
                        <input type="time" class="form-control" id="cmHour" v-model="scheduleHour" />
                      </div>
                    </div>

                    <!-- Message Content -->
                    <div class="mb-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <label for="cmMessageContent" class="form-label fw-semibold mb-0">
                          <i class="ri-file-text-line me-1 text-primary"></i>Message Content
                        </label>
                        <span id="char_count" :class="characterCountBadgeClass">{{ characterCountDisplay }}</span>
                      </div>
                      <textarea
                          class="form-control"
                          id="cmMessageContent"
                          rows="15"
                          v-model="scheduleMessageContent"
                          placeholder="Type your message here..."
                          style="resize: none;"
                      ></textarea>
                      <div v-if="characterCount > 150" class="alert alert-danger mt-2 mb-0 py-2 px-3">
                        <i class="ri-error-warning-line me-1"></i>
                        <small><strong>Message too long!</strong> Please reduce to 150 characters or less.</small>
                      </div>
                    </div>

                    <!-- Message Stats -->
                    <div class="alert alert-info mb-0" role="alert">
                      <div class="d-flex align-items-center mb-2">
                        <i class="ri-information-line me-2 fs-18"></i>
                        <strong>Message Summary</strong>
                      </div>
                      <div class="row text-center">
                        <div class="col-6">
                          <div class="border-end">
                            <h4 class="mb-0 text-primary">{{ availableMessages }}</h4>
                            <small class="text-muted">Remaining Messages</small>
                          </div>
                        </div>
                        <div class="col-6">
                          <h4 class="mb-0 text-success">{{ numberOfRecipents }}</h4>
                          <small class="text-muted">Recipients Selected</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- RIGHT SIDE - Recipients Selection -->
              <div class="col-lg-7">
                <div class="card shadow-sm h-100">
                  <div class="card-header bg-success text-white">
                    <h6 class="mb-0"><i class="ri-user-add-line me-2"></i>Select Recipients</h6>
                  </div>
                  <div class="card-body">
                    <!-- Filter Controls -->
                    <div class="row g-3 mb-3">
                      <div class="col-sm-6">
                        <label for="cmKeyword" class="form-label fw-semibold">
                          <i class="ri-search-line me-1 text-success"></i>Search
                        </label>
                        <input
                            type="text"
                            id="cmKeyword"
                            name="cmKeyword"
                            class="form-control"
                            placeholder="Search by name, email, or phone..."
                            v-model="data.searchValues.keyword"
                            @input="data.searchValues.keyword.length >= 3 ? updateAgentList() : null"
                            @keyup.enter="data.searchValues.keyword === '' ? updateAgentList() : null"
                        />
                      </div>

                      <div class="col-sm-3">
                        <label for="cmLicensed" class="form-label fw-semibold">
                          <i class="ri-shield-check-line me-1 text-success"></i>Licensed
                        </label>
                        <select
                            class="form-select"
                            id="cmLicensed"
                            name="cmLicensed"
                            v-model="data.searchValues.licensed"
                            @change.stop.prevent="updateRecipientsList"
                        >
                          <option value="1">Both</option>
                          <option value="2">Yes</option>
                          <option value="3">No</option>
                        </select>
                      </div>

                      <div class="col-sm-3">
                        <label for="cmLanguage" class="form-label fw-semibold">
                          <i class="ri-global-line me-1 text-success"></i>Language
                        </label>
                        <select
                            class="form-select"
                            id="cmLanguage"
                            name="cmLanguage"
                            v-model="data.searchValues.language"
                            @change.stop.prevent="updateRecipientsList"
                        >
                          <option value="3">Both</option>
                          <option value="1">English</option>
                          <option value="2">Spanish</option>
                        </select>
                      </div>
                    </div>

                    <div class="row g-3 mb-3">
                      <div class="col-sm-4">
                        <label for="cmRecipientsList" class="form-label fw-semibold">
                          <i class="ri-team-line me-1 text-success"></i>Recipients Type
                        </label>
                        <select
                            class="form-select"
                            id="cmRecipientsList"
                            name="cmRecipientsList"
                            v-model="findAgents"
                        >
                          <option value="1">Agents</option>
                          <option value="2">Clients</option>
                          <option value="3">Prospects</option>
                        </select>
                      </div>

                      <div class="col-sm-4">
                        <label for="cmStatus" class="form-label fw-semibold">
                          <i class="ri-price-tag-3-line me-1 text-success"></i>Status
                        </label>
                        <select
                            class="form-select"
                            id="cmStatus"
                            v-model="data.searchValues.status"
                            @change.stop.prevent="updateRecipientsList"
                        >
                          <option value="0">All</option>
                          <option v-for="(status, statusIndex) of statusList" :key="statusIndex" :value="status.statusID">
                            {{ status.name }}
                          </option>
                        </select>
                      </div>

                      <div class="col-sm-4">
                        <label for="cmType" class="form-label fw-semibold">
                          <i class="ri-list-check me-1 text-success"></i>Type
                        </label>
                        <select
                            class="form-select"
                            id="cmType"
                            name="cmType"
                            v-model="data.searchValues.type"
                            @change.stop.prevent="updateRecipientsList"
                        >
                          <option value="0">All</option>
                          <option v-for="(type, typeIndex) of typeList" :key="typeIndex" :value="type.name">
                            {{ type.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- MAIN LIST -->
                    <div class="border rounded p-2 mb-3" style="max-height: 450px; overflow-y: auto;">
                      <table class="table table-hover align-middle table-nowrap mb-0">
                        <thead class="table-light" style="position: sticky; top: 0; z-index: 10;">
                        <tr>
                          <th scope="col" style="width: 50px">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="checkAllRecipients" @change="toggleSelectAll" />
                            </div>
                          </th>
                          <th scope="col">Name</th>
                          <th scope="col">Status</th>
                          <th scope="col">Phone</th>
                          <th scope="col">Department</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="(row, index) in resultQuery" :key="findAgents + '-' + (row.ID || index)" :class="{'table-active': isRowSelected()}">
                          <td>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" name="chk_child_main" value="option1" @change="toggleRowSelection($event)" />
                            </div>
                          </td>

                          <td class="id" style="display: none">
                            <a href="javascript:void(0);" class="fw-medium link-primary">{{ row.ID }}</a>
                          </td>

                          <td class="fw-medium">{{ row.firstName }} {{ row.lastName }}</td>
                          <td>
                            <span class="badge bg-success-subtle text-success">{{ row.statusName }}</span>
                          </td>
                          <td>{{ formatPhone(row.phoneNumber) }}</td>
                          <td><small class="text-muted">{{ row.departmentName }}</small></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2" v-if="resultQuery.length > 0">
                      <button
                          type="button"
                          class="btn btn-success"
                          @click="addRecipients()"
                      >
                        <i class="ri-user-add-line me-1"></i>Add Selected Recipients
                      </button>

                      <div class="dropdown">
                        <button type="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false" class="btn btn-info">
                          <i class="ri-more-2-fill"></i> More Options
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                          <li><a class="dropdown-item" href="#uploadRecipients" data-bs-toggle="modal">
                            <i class="ri-upload-2-line me-2"></i>Upload Recipients
                          </a></li>
                        </ul>
                      </div>

                      <div class="pagination-wrap hstack gap-2">
                        <a class="page-item pagination-prev" href="#" v-if="page !== 1" @click="page--">
                          <i class="ri-arrow-left-s-line"></i> Previous
                        </a>
                        <ul class="pagination listjs-pagination mb-0">
                          <li
                              :class="{ active: pageNumber == page, disabled: pageNumber == '...' }"
                              v-for="(pageNumber, index) in pages.slice(page - 1, page + 5)"
                              :key="index"
                              @click="page = pageNumber"
                          >
                            <a class="page" href="#">{{ pageNumber }}</a>
                          </li>
                        </ul>
                        <a class="page-item pagination-next" href="#" @click="page++" v-if="page < pages.length">
                          Next <i class="ri-arrow-right-s-line"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- RECIPIENTS LIST SECTION -->
            <div class="row mt-4">
              <div class="col-12">
                <div class="card shadow-sm">
                  <div class="card-header bg-warning text-dark">
                    <h6 class="mb-0"><i class="ri-user-follow-line me-2"></i>Selected Recipients ({{ numberOfRecipents }})</h6>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive" style="max-height: 400px;">
                      <table class="table table-hover align-middle table-nowrap mb-0">
                        <thead class="table-light" style="position: sticky; top: 0; z-index: 10;">
                        <tr>
                          <th scope="col" style="width: 50px">#</th>
                          <th scope="col">Name</th>
                          <th scope="col">Status</th>
                          <th scope="col">Phone</th>
                          <th scope="col">Department</th>
                          <th scope="col" class="text-center">Action</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="(data, index) of reciepientList" :key="index">
                          <td>
                            <div class="form-check">
                              <!-- FIX: nombre distinto para no chocar con addRecipients -->
                              <input class="form-check-input" type="checkbox" name="chk_child_selected" value="option1" />
                            </div>
                          </td>

                          <td class="id" style="display: none">
                            <a href="javascript:void(0);" class="fw-medium link-primary">{{ data.ID }}</a>
                          </td>

                          <td class="fw-medium">{{ data.firstName }} {{ data.lastName }}</td>
                          <td><span class="badge bg-success-subtle text-success">{{ data.statusName }}</span></td>
                          <td>{{ formatPhone(data.phoneNumber) }}</td>
                          <td><small class="text-muted">{{ data.departmentName }}</small></td>

                          <td class="text-center">
                            <button variant="danger" class="btn btn-sm btn-danger waves-effect waves-light" @click="removeRecipient(index)">
                              <i class="ri-delete-bin-5-line"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>

                      </table>
                      <div v-if="reciepientList.length === 0" class="text-center text-muted py-4">
                        <i class="ri-user-unfollow-line fs-1 mb-2 d-block"></i>
                        <p>No recipients selected yet. Select contacts from the list above.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer border-top">
            <button type="button" class="btn btn-light btn-lg" id="closemodal" data-bs-dismiss="modal">
              <i class="ri-close-line me-1"></i>Close
            </button>
            <button type="button" class="btn btn-success btn-lg" @click="scheduleMessage()" :disabled="!canScheduleMessage">
              <i class="ri-send-plane-fill me-1"></i>Schedule Message
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Upload Recipients Modal -->
    <b-modal id="uploadRecipients" title="Fullscreen | Upload Clients" class="v-modal-custom" fullscreen>
      <div class="row">
        <div class="col-lg-12">
          <form>
            <div class="card">
              <div class="card-body">
                <div class="vstack gap-2">
                  <h5 class="fs-14 mb-1">Upload Your Recipients List</h5>
                  <h6><span style="color:red; font-size: 0.7em;">Please, upload a .csv file or convert the .xls/.xlsx to .csv</span></h6>

                  <input class="form-control" id="listFile" type="file" accept="text/csv" @change="handleFileUpload" />

                  <div class="row">
                    <div class="col-lg-3">
                      <label for="uploadLanguage" class="form-label">Language</label>
                      <select class="form-select mb-2" aria-label="Language" id="uploadLanguage" name="uploadLanguage" v-model="uploadLanguage">
                        <option value="0">...</option>
                        <option value="1">English</option>
                        <option value="2">Spanish</option>
                      </select>
                    </div>
                  </div>

                  <div class="text-end mb-3">
                    <button type="button" class="btn btn-success w-sm" @click="handleFileUpload">Process File</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="card">
          <div class="card-body">
            <table class="table table-bordered border-secondary table-nowrap" v-if="parsed">
              <thead>
              <tr>
                <th scope="col">ID</th>
                <th v-for="(header, key) in content.meta.fields" :key="'header-'+key" scope="col">{{ header }}</th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="(row, rowKey) in content.data" :key="'row-'+rowKey">
                <td><b>{{ rowKey + 1 }}</b></td>
                <td v-for="(column, columnKey) in content.meta.fields" :key="'row-'+rowKey+'-column-'+columnKey">
                  {{ content.data[rowKey][column] }}
                </td>
              </tr>
              </tbody>

            </table>
          </div>
        </div>

        <div class="text-end mb-3">
          <button type="button" class="btn btn-light" id="closeListModal" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-success w-sm" @click="addRecipientsFromFile">Add to recipients list</button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
